module.exports = __webpack_public_path__ + "img/Nader Dabit.e6aadf57.jpg";